export const OFFER_TYPE_TABLE_CHART_POINTS = {
  GREAT_CHART_POINTS_NUM: 12,
  GOOD_CHART_POINTS_NUM: 19,
  FAIR_CHART_POINTS_NUM: 15,
  HIGH_CHART_POINTS_NUM: 15,
  DATA_LENGTH: 61,
};

export const CHART_MARGINS = { top: 0, right: 0, left: 0, bottom: 0 };
export const CHART_VALUE_CHANGED = 'chart_value_changed';
export const CHART_VALUE_CHANGED_OUTSIDE = 'chart_value_changed_outside';

export const SLIDER_POSITION = { high: 51 };
